<template>
  <div>
    <b-form @submit.prevent="onSubmit" v-if="!sent">
      <b-form-group class="required" label="Email">
        <b-form-input
          v-model="email"
          autocomplete="off"
          :state="$v.email.$error? false : null"
          @input="$v.email.$reset()"
        />
      </b-form-group>

      <b-form-group class="text-right">
        <b-button type="submit" variant="primary" block :disabled="loading">
          <span v-show="!loading">Wyślij email</span>
          <span v-show="loading">
            <b-spinner small label="Loading..."></b-spinner>
          </span>
        </b-button>
        <b-button variant="link" @click="goto('/public/login')">Zaloguj się</b-button>
      </b-form-group>
    </b-form>
    <success v-else />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, email } from "vuelidate/lib/validators";
import success from "./ForgotPasswordSuccess";

export default {
  data() {
    return {
      email: "",
      loading: false,
      sent: false
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  components: {
    success
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.loading = true;

        axios
          .post("/auth/forgotpassword", { email: this.email })
          .then(() => {
            this.sent = true;
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.loading = false));
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-link {
    font-size: 0.75rem;
    text-decoration: none;
  }
}
</style>